"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  contract: {
    messageThree: 'Please select the voyage to be arranged',
    successMessage: 'The voyage assignment is successful',
    messageTwo: 'You can only choose one',
    contractNoone: 'Pending contract',
    movement: 'Ship dynamics',
    //shipName:'Name of ship',
    voyageTypeOne: 'Voyage type',
    btnVoyageOne: 'Assign voyage tasks',
    refresh: 'Refresh',
    btnVoyage: 'Arrange voyage',
    registrationWithSeal: 'registration With Seal',
    numberOfSealsUsed: 'Number of seals used',
    printingTime: 'Printing time',
    arrangement: 'Arrangement',
    isDispute: 'Is a dispute',
    isInsurance: 'Is a Insurance',
    disputeAmount: 'Dispute amount (original currency)',
    Equivalent: 'Dispute amount (base currency)',
    DisputeDesc: 'Dispute Desc',
    DealMode: 'Deal Mode',
    ExternalLawyerFlag: 'External Lawy erFlag',
    LawFirmName: 'Law Firm Name',
    DealDesc: 'Deal Desc',
    Desc: 'Desc',
    cargoLoad: 'Unmaintained voyage cargo load',
    importData: 'import data',
    noDeliveryInfo: 'Unlocked delivery information',
    look: 'Loook',
    addVessage: 'Add ship and voyage',
    searchFilterOne: 'Can Searching ShipOwner OR Broker',
    searchFilterTwo: 'Can Searching Renter OR Broker',
    searchFilterThree: 'Can Searching ShipOwner OR companyName',
    contract: 'Contract',
    information: 'Ship rental information inquiry',
    latestChtrsoutInfo: 'Current information query of the rented ship',
    allChtrsOutiInfo: 'Rental ship combination query',
    contractStopSuccess: 'Contract Stop Success',
    contractStopFail: 'Contract Stop Failed',
    contractStop: 'Contract Stop',
    approveType: 'Approve Type',
    approveStatus: 'Approve Status',
    approveTime: 'Approve Time',
    handler: 'handler',
    handleTaskNode: 'handle Task Node',
    price: 'price',
    loadPort: 'load Port',
    DischargePort: 'Discharge Port',
    demurrageCarges: 'demurrage Carges',
    // taxFlag: 'Tax Flag',
    contractRoute: 'Contract Route',
    // cargoGroup:'Cargo Group',
    demuClaimLimitFlag: 'Demu Claim Limit Flag',
    limitTermsFlag: 'Limit Terms Flag',
    pleaseEnterBatchAndQuantity: 'Please Enter BatchAndQuantity',
    contractVersion: 'Contract Version',
    lastModifyByName: 'Last Modify By Name',
    lastModifyTime: 'Last Modify Time',
    createTime: 'create Time',
    jurisdiction: 'jurisdiction',
    applicableLaw: 'Applicable Law',
    contractTemplateCode: 'Contract Template Code',
    contractTemplate: 'Contract Template',
    effectiveDesc: 'Effective Desc',
    contractSignApproval: 'Contract Sign Approval',
    contractChangeApproval: 'Contract Change Approval',
    contractStopApproval: 'Contract Stop Approval',
    editHistoryContract: 'Contract Change',
    cargoLoadStartTime: 'Cargo Load Start Time',
    cargoLoadEndTime: 'Cargo Load End Time',
    cargoName: 'Cargo Name',
    cargoPlan: 'Cargo Plan',
    unitBatchQuantity: 'unit Batch Quantity',
    makeInfo: 'Make Information',
    totalLoadMin: 'Total Load Min',
    totalLoadMax: 'Total Load Max',
    loadAppointor: 'Load Appointor',
    lockBeginDate: 'Lock Begin Date',
    lockEndDate: 'Lock End Date',
    lockDay: 'Lock Day',
    inShipContract: 'Lease-out Ship Contract',
    outShipContract: 'Lease-in Ship Contract',
    coaAndVcvContract: 'COA/CVC Contract',
    viewVideoFiles: 'View video files',
    deleteSuccess: 'Delete succeeded',
    deleteFail: 'Delete failed',
    contractNo: 'contractNo',
    vesselName: 'ship',
    companyNameEn: 'company Name En',
    contractType: 'Type of contract',
    coaContractNo: 'Own Coa Contract',
    voyageNo: 'Voyage number',
    chartererName: 'tenant',
    contractStatus: 'Contract status',
    createName: 'salesman',
    majorFlag: 'Material contract mark',
    vesselType: 'Form part',
    title: 'TC-IN/OUT contract editor',
    escrowTitle: 'Business Escrow Contract editor',
    oneTitle: 'Experience management',
    twoTitle: 'Charter party management',
    twoEscrowTitle: 'Business Escrow Contract',
    editOBO: 'OBO contract editing',
    vcInTitle: 'VC-IN Contract',
    vcOutTitle: 'VC-OUT Contract',
    fourTitle: 'Approval Form of Charter Party',
    manageApproval: 'Approval Form for Business Administration Contract',
    fiveTitle: 'Charter Party Approval Form',
    print: 'print',
    contractInvalid: 'Contract invalid',
    task: 'Assign voyage tasks',
    contractSuccess: 'Completion of contract',
    copyOBO: 'Copy OBO contract',
    copyVc: 'Copy VC-IN contract',
    copyVcOut: 'Copy VC-OUT contract',
    void: 'Cancellation of contract',
    splittingContracts: 'Splitting contracts',
    edit: 'Modified economy',
    contractName: 'Contract Name',
    placeholder: 'Please enter the content',
    placeholderSelect: 'Please select',
    contractDate: 'Contract Date',
    fleetName: 'Fleet Name',
    voyageType: 'Voyage Type',
    summaryCommRate: 'Summary CommRate',
    contractCurrency: 'Contract Currency',
    tradeFlag: 'Trade Flag',
    titleTwo: 'Ship information',
    vesselSummerWeight: 'Summer Deadweight',
    vesselFullLoaddraft: 'Full Load Draft',
    vesselDesc: 'Vessel Desc',
    titieThree: 'Signing information',
    signSubjectName: 'Sign Subject',
    signNetwork: 'Sign Network',
    signatory: 'Signatory',
    ourSignatory: 'Our signatory',
    counterpartySignatory: 'Counterparty signatory',
    isProvideSecurity: 'IS Provide Security',
    isSublet: 'IS Sublet',
    agentName: 'Agent Name',
    beginDate: 'Begin Date',
    endDate: 'End Date',
    pleaseEnterBeginDate: 'Please Enter Begin Date',
    pleaseEnterEndDate: 'Please Enter End Date',
    tenancyDate: 'Tenancy Begin Date',
    // isSublet: 'IS Sublet',
    chartererComm: 'Charterer Comm',
    signArea: 'Gign Area',
    brokerName: 'Broker Name',
    brokerBillStandards: 'Bill Standards',
    commPayer: 'Payer',
    brokerCommDesc: 'Commission Desc',
    // brokerName: 'Broker Name',
    shipmentAndCargoInfo: 'Shipment And Cargo Information',
    attInformation: 'Attachment information',
    otherTerms: 'Other terms',
    norTerms: 'Nor terms',
    oneTable: 'Lease term/rent',
    twoTab: 'Quantity information',
    threeTab: 'Redelivery information',
    fourTab: 'Other terms',
    fiveTab: 'Attachment information',
    sixTab: 'Contract filing and legal information',
    sevenTab: 'Other terms and limitations',
    standard: 'standard',
    index: 'index',
    fileName: 'file name',
    mix: 'mix',
    rentType: 'Rent Type',
    feeType: 'Fee Type',
    feeNum: 'fee Num',
    dateTime: 'Date of delivery',
    rentLength: 'Is Laden Legs',
    custodyPeriod: 'custody Period',
    ctaxStandard: 'C Tax Standard',
    unit: '(USD/ton)',
    // chartererBear: 'Charterer Bear',
    ctaxStandardRemark: 'Carbon tax remarks',
    LeaseInformation: 'Lease information',
    LeaseInformationone: 'Rent/Voyage Information',
    periodStartTime: 'Rent Start Time',
    periodEndTime: 'Rent End Time',
    periodDay: 'Rent Days',
    periodRentDay: 'Rent Per Day',
    layBeginDate: 'Start of loading period',
    layEndDate: 'End of loading period',
    cTaxStandard: 'Carbon tax standard',
    cTaxStandardUnit: 'Carbon tax standard Unit',
    chartererBear: 'Charterer Bear',
    pleaseChooseTime: 'Please Choose Time',
    rateInformation: 'Freight rate information',
    freightType: 'Freight Type',
    freightFee1: 'Freight Fee',
    freightRate: 'Freight Rate',
    freightTax: 'Freight Tax',
    cargoInformation: 'Cargo information',
    excess: 'excess',
    dockInformation: 'Loading and unloading information',
    delayFeeAndOtherExpenses: 'Delay fee&other expenses',
    cargoOqMin: 'Cargo Oq Min',
    cargoOqMax: 'Cargo Oq Max',
    cargoOqStandards: 'Cargo Oq Standards',
    cargoOqMode: 'Cargo Oq Mode',
    invoiceType: 'Invoice Type',
    freightDesc: 'Freight Desc',
    attaFeeTerms: 'Atta Fee Terms',
    attaFeeTerms2: 'Surcharge clause',
    cargoType: 'Cargo Type',
    cargoUnit: 'Cargo Unit',
    cargoCode: 'Goods Code',
    cargoQuantity: 'Cargo Quantity',
    weight: 'weight',
    volumeNumber: 'Volume Number',
    cargoDesc: 'Cargo Desc',
    polOrArea: 'pol Or Area',
    podOrArea: 'pod Or Area',
    loadEfficiency: 'Load Efficiency Or Time',
    loadEfficiencyUint: 'Load Efficiency Unit',
    dischargeEfficiency: 'Discharge Efficiency Or Time',
    dischargeEfficiencyUnit: 'Discharge Efficiency Unit',
    totalHandling: 'Total Handling',
    layTerm: 'Lay Term',
    demurrageRate: 'Demurrage Rate',
    delayRate: 'Delay Rate',
    dispatchRate: 'Dispatch Rate',
    demurrageDispatchTerms: 'Demurrage Dispatch Terms',
    demuDispTermDesc: 'Demurrage Dispatch Terms',
    otherFeeDesc: 'Other Fee Desc',
    open: 'open',
    close: 'close',
    limitTerms: 'Limit Terms',
    demuClaimLimit: 'Demurrage Claim Limit',
    otherClaimLimit: 'Other Claim Limit',
    // cargoOqMode: 'Cargo Oq Mode',
    messageTime: 'Please fill in the start time or end time',
    indexCalcMode: 'Index Calculate Mode',
    indexCompMode: 'Index Complement Mode',
    isIndexRange: 'Set Index Range',
    compareMode: 'Compare Mode',
    isOriginalContract: 'Is Original Contract',
    isBreakingIwl: 'Is Breaking Iwl',
    isCargoArea: 'Is Cargo Area',
    escrowContractNo: 'Escrow Contract No',
    vesselEstStartTime: 'Vessel Est Start Time',
    vesselEstDay: 'Vessel Est Day',
    commModel: 'Comm Model',
    isDeducted: 'Is Deducted',
    actualCharterer: 'Actual Charterer',
    isChartererEnable: 'Is Charterer Enable',
    tipOne: 'If there is an actual tenant and it is inconsistent with the tenant, you need to enter the actual tenant and submit it for approval',
    owner: 'owner',
    ownerComm: 'Owner Comm',
    ownerCommUnit: 'Owner Comm unit',
    ownerSignatory: 'Owner Signatory',
    otherInformation: 'Other Information',
    pdpr: ' PDPR',
    contractSummary: 'Contract Summary',
    contractEvaluation: 'Contract Evaluation',
    palletNo: 'Pallet No',
    batchNo: 'Batch No',
    isForwardPallet: 'Is Forward Pallet',
    route: 'Route weight',
    rounte: 'Rounte',
    indexWeight: 'Weight(%)',
    indexFloor: 'Index Ceil',
    cargoVolumeMax: 'Cargo volume max',
    ILOW: 'ILOW terms(%)',
    placeholder7: 'Please click to select a route',
    freightFeeType: 'Freight rate type',
    placeholder8: 'Click to use formula calculator',
    indexCeiling: 'Index Floor',
    formulaCalculator: 'Formula Calculator',
    indexFormula: 'Formula',
    paymentFrequency: 'Payment Frequency',
    ballastComp: 'Ballast Compensation(Yuan)',
    loadPortName: 'POL Or Area',
    dischargePortName: 'POD Or Area',
    // cargoType: 'Cargo Type',
    cargoQuantityMin: 'Cargo Quantity Min',
    cargoQuantityMax: 'Cargo Quantity Max',
    // cargoUnit: 'Cargo Unit',
    cargoQuantityFloat: 'Cargo Quantity Float',
    // cargoDesc: 'Cargo Desc'
    ship: 'Expected delivery',
    shipone: 'Expected return',
    eDelHfoPrice: 'Hsfo Price',
    eDelIfoPrice: 'lsfo Price',
    yuan: 'yuan',
    eDelHdoPrice: 'Hsmgo Price',
    eDelIdoPrice: 'Lsmgo Price',
    eDelType: 'Delivery Terms',
    eEPrice: 'Is Delivery Same Price',
    eDelPaymode: 'Delivery Way',
    eDelPorts: 'Delivery time place',
    eDelRemark: 'Delivery remark',
    eRedType: 'Redelivery Terms',
    eRedPaymode: 'Redelivery Way',
    eREPrice: 'Is Redelivery Same Price',
    eRedPorts: 'Redelivery Time Or Place',
    eRedRemark: 'Redelivery Remark',
    depositeMode: 'Deposite Mode',
    depositeRentDays: 'Deposite Rent Days',
    cve: 'C/V/E(Yuan)',
    ILOHC: 'ILOHC',
    rentDesc: 'Rent Desc',
    escrowDescription: 'escrow Description',
    ownerName: 'Owner',
    mgCompanyName: 'mg Company Name',
    ownerName02: 'Actual payee',
    importantFlag: 'Is Important',
    cargoGroup: 'Cargo Group',
    submit: 'submit',
    contractInvalidSuccess: 'Contract takes effect successfully',
    contractInvalidFail: 'Contract validation failed',
    contractFinishSuccess: 'Contract completed successfully',
    contractFinishFail: 'Contract completion failed',
    contractVoidSuccess: 'Contract voided successfully',
    contractVoidFail: 'Failed to void the contract',
    failMessage: 'Save failed please try again',
    cuplicateContractNumber: 'Duplicate contract number',
    handlingFee: 'Handling Fee',
    returnedDrafter: 'Returned drafter',
    makeCopyFor: 'make a copy for',
    viewContractSummary: 'View contract summary',
    viewRECAP: 'View RECAP',
    viewVoyageCalculation: 'View voyage calculation',
    approval: 'Approval',
    withdraw: 'withdraw',
    approvalType: 'Approval type',
    shipName: 'Ship name',
    riskControlScreening: 'Risk control screening',
    screeningType: 'Screening type',
    report: 'report',
    reportingTime: 'Reporting time',
    operation: 'operation',
    shipCode: 'Ship Code',
    deadweightTon: 'Deadweight ton',
    builtinfo: 'Year and place of construction',
    totalLength: 'Total length',
    wide: 'wide',
    grossTon: 'Gross ton',
    speed: 'Speed L/B',
    fuelConsumption: 'Fuel consumption',
    other: 'other',
    mainIdeaOfTheLease: 'Main idea of the lease',
    loadingPeriod: 'Loading period',
    delivery: 'Delivery (loading port)',
    redelivery: 'Redelivery (unloading port)',
    timeLease: 'Time lease',
    rent: 'Rent (freight)',
    brokerageCommission: 'Brokerage/commission',
    approvalComments: 'Approval comments',
    serialNumber: 'Serial number',
    approvalProcess: 'Approval process',
    approver: 'Approver',
    approvalTime: 'Approval time',
    corporateName: 'corporate name',
    approvalDepartment: 'Approval department',
    approvalOperation: 'Approval operation',
    rentTitle: 'Approval Form of Charter Party',
    approvalFormForCharteredShips: 'Approval Form for Hired Ships of Haihong Shipping (Hong Kong) Co., Ltd',
    internalApprovalFormOfShipLeaseContract: 'Internal Approval Form for Ship Leasing Contract of Haihong Shipping (Hong Kong) Co., Ltd',
    laycan: 'Laycan',
    contractApprovalTitle: 'Contract approval form (bulk cargo)',
    internalApprovalForm1: 'Internal approval form of ship charter contract (non material)',
    internalApprovalForm2: 'Internal approval form of ship charter contract (major)',
    loadingUnloadingInformation: 'Loading and unloading information',
    leaseCommission: 'Lease commission',
    listOfAttachments: 'List of attachments',
    relevantProvisions: 'Relevant provisions',
    specialprescription: 'Special prescription',
    effectedDate: 'Effected Date',
    endDatePool: 'End Date',
    signRemark: 'Sign Remark',
    companyName: 'Pool Company',
    poolOneTable: 'Management fee/lease term rent',
    deposit: 'Deposit',
    deposit2: 'Deposit',
    managementFee: 'Management Fee',
    managementComm: 'Management Fee Comm',
    managementTime: 'Management Fee/Time',
    managementFeeRemark: 'Management Fee Desc',
    rentpayTerm: 'Rentpay Term',
    exitPoolTerm: 'Exit Pool Term',
    messageInfo: 'The contract number is duplicate. Please select a new one',
    editContractVersion: 'Editorial history contract',
    preservation: 'preservation',
    abstractContract: 'Abstract of contract',
    seventTab: 'Voyage calculation',
    eightTab: 'Execution voyage',
    nightTab: 'Tenancy history contract',
    elevenTab: 'Shipowner historical contract',
    tenTab: 'Chartered historical voyage',
    twelveTba: 'Shipowner historical voyage',
    nineTen: 'Contract approval form',
    twfTab: 'Contract filing',
    contractSign: 'Contract signing and approval',
    contractChange: 'Contract change approval',
    contractterminna: 'Contract termination approval',
    companyNameOne: ' Pool Company',
    taxFlag: 'Whether tax words are included',
    validateMessage: 'Please fill in the required items correctly',
    oneMessage: 'One piece of data must exist',
    nonchartering: 'Non-charter party management contract',
    year: 'a particular year',
    contractIsFile: 'Whether to archive',
    contractNo2: 'Contract No',
    handlingDepartment: 'Handling department',
    Amount: 'Amount in original currency',
    placeholder2: 'Please enter',
    ourTheme: 'Our theme',
    subjectOfTheOtherOarty: 'Subject of the other party',
    originalCurrency: 'Original currency',
    rmbAmount: 'RMB amount',
    performancePeriod: 'Performance period',
    signingDate: 'Signing date',
    signer: 'Signer',
    legalReview: 'Legal review',
    audiStatus: 'Audit status',
    noncharteringEdit: 'Editing of non-charter party management contract',
    approvalOfMajorContractSigning: 'Approval of major contract signing',
    leaseAndAttachments: 'Lease and attachments',
    textAndData: 'Text and data',
    performance: 'Performance',
    contractYear: 'Contract year',
    contractScore: 'Contract score',
    urgency: 'Urgency',
    moneyFlow: 'money flow',
    bidWinningDate: 'Bid winning date',
    expectedSigningDate: 'Expected signing date',
    signingPlace: 'Signing place',
    endDate2: 'End date',
    effectiveConditions: 'Effective conditions',
    targetAmount: 'Target amount',
    amountOfMoney: 'amount of money',
    currency: 'currency',
    exchangeRateAgainstRMB: 'Exchange rate against RMB',
    subjectMatterOfContract: 'Subject matter of contract',
    contractPeriod: 'contract period',
    legalReviewOrNot: 'Legal review or not',
    mainTerms: 'Main terms',
    sanctionsComplianceReview: 'Sanctions compliance review',
    abstractContractRemarks: 'Remarks: whether the other party to the contract, the consignee and consignor, the goods and the country where the loading and unloading port are located are subject to sanctions from the United Nations, the European Union, the United Kingdom, the United States or other countries and regions.',
    shipTypeInformation: 'Ship type information',
    associationType: 'Association type',
    shipType: 'Ship type',
    ourContractInformation: 'Our contract information',
    guaranteeContract: 'Whether to provide guarantee for the contract',
    guaranteeUnit: 'Guarantee unit',
    ourBackground: 'Our background',
    counterpartyInformation: 'Counterparty information',
    oppositeParty: 'Opposite party',
    oppositeBackground: 'Opposite background',
    classify: 'classify',
    attachmentType: 'Attachment type',
    attachmentTitle: 'Attachment Title',
    creationTime: 'Creation time',
    createdBy: 'Created by',
    modifiedBy: 'Modified by',
    modificationTime: 'Modification time',
    confirmArchiving: 'confirm Archiving',
    legalSystem: 'Send the legal system',
    testSending: 'test Sending',
    contractFilingDate: 'Contract filing date',
    contractArchiver: 'Contract Archiver',
    totalContract: 'Total number of copies of contract',
    filingPeriod: 'Filing period',
    contractFilingDepartment: 'Contract filing department',
    numberContract: 'Number of contract files',
    otherOriginalHoldingDepartments: 'Other original holding departments',
    numberOfSharesHeld: 'Number of shares held',
    riskLevel: 'Risk level',
    placeOfArbitration: 'Place of arbitration',
    pointOut: 'point out',
    contractOppNo: 'Contract No. of the other party',
    secretFlag: 'Whether classified',
    foreignFlag: 'Foreign contract or not',
    importantFlagLc: 'Whether the ship has a major contract',
    importantHMFlag: 'Whether Minghua major contract',
    lawFlag: 'Legal review or not',
    noncharteringContractApprovalForm: 'Approval form of non-charter party management contract',
    viewAttachments: 'View attachments',
    exportDoc: 'Export Doc',
    viewForwardPallets: 'View forward pallets',
    noncharteringContractApprovalFormTitle: 'Internal approval form of non-charter party (non material)',
    contractSubject: 'Contract subject',
    opponents: 'Opponents',
    duration: 'Duration',
    opponentBackground: 'Opponent\'s background',
    opponentBackgroundCheck01: 'Certificat of Incorporation or Business Registration',
    objectAmount: 'Object/Amount',
    contractCopy: 'Copy New Contract',
    lawJurisdiction: 'Applicable Law/Jurisdiction',
    placeDateSigning: 'Place/Date of Signing',
    sanctionsComplianceReviewText: 'After review, it is not found that the other party to the contract, the consignee and consignor, the goods and the country where the loading and unloading port are located are subject to sanctions from the United Nations, the European Union, the United Kingdom, the United States or other countries and regions',
    fixedLoadDate: 'Fixed load date',
    delayFee: 'Demurrage fee',
    classificationFfGoods: 'Classification of goods',
    carryingCargoYype: 'Carrying cargo type',
    brokerInformation: 'Broker Information',
    expectedReturnVessel: 'Expected return of vessel',
    NatureLeaseTerm: 'Nature of lease term',
    routeIndex: 'Route index',
    indexRange: 'Index range',
    POOLManagement: 'POOL management',
    backContract: 'Back-to-back contract',
    demurrageCommission: 'Demurrage commission',
    freightandVolume: 'Freight and volume',
    quantityDesignatedParty: 'Quantity designated party',
    loadingPeriodInformation: 'Loading period information',
    loadingPort: 'Loading Port',
    dischargingPort: 'discharging port',
    loadingArea: 'Loading area',
    unloadingArea: 'Unloading area',
    dischargeTerms: 'Discharge terms',
    totalLoading: 'Total loading and unloading terms',
    loadingUnloadingRemarks: 'Loading and unloading remarks',
    BAFAdjustment: 'BAF fuel adjustment',
    benchmarkOilPrice: 'Benchmark oil price',
    estimatedOilPrice: 'Estimated actual oil price',
    rate: 'Rate',
    minghuaSteamship: 'Reported to',
    placeholder5: 'Please enter the lease term length information',
    placeholder4: 'Please enter the nature of the lease term information',
    placeholder6: 'Please enter carbon tax information',
    placeholder9: 'Please enter the custody period information',
    hongKongMinghua: 'Hong Kong Minghua',
    placeholder3: 'Please enter the delivery date information',
    steamboat: 'ship',
    indexType: 'index type',
    describe: 'describe',
    unitPrice: 'unit-price',
    lumpSum: 'Lump sum',
    startingTimeLeaseTerm: 'Starting time of loading period',
    leaseEndTime: 'Ending time of loading period',
    quantitySingleCargo: 'Quantity of single cargo',
    designatedSingleCargoCapacity: 'Designated party for single cargo capacity',
    totalCargoQuantity: 'Total cargo qufversionantity',
    totalLoad: 'Total load',
    designatedPartyTotalCargoCapacity: 'Designated party for total cargo capacity',
    freightTax2: 'freight tax',
    version: 'version',
    termInformation: 'Term Information',
    receivingCommission: 'receiving commission',
    time: 'time',
    historicalContracts: 'Historical contracts',
    recordChangesFreightRates: 'Record of changes in freight rates',
    otherExpenses: 'other expenses',
    startPort: 'Start Port',
    endPort: 'End Port',
    coefficient: 'coefficient',
    QuantityOfGoods: 'Quantity of goods',
    affiliatedVC: 'Affiliated VC Parent Contract',
    freightRateBefore: 'freightRateBefore',
    adjustType: 'adjustType',
    adjuster: 'adjuster',
    adjustTime: 'adjustTime',
    actualCargo: 'actual Cargo'
  }
};